import { defineMessages } from 'react-intl';

export default defineMessages({
  sourceSlogan: {
    id: 'global_home_uvp_description',
    defaultMessage:
      'Trovit collaborates with thousands of websites to help you find what you are looking for.',
  },
});



// WEBPACK FOOTER //
// ./app/Sources/list/components/SourcesList/messages.js